/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. MMXXIV`)
};

const es_rn_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p. ej. MMXXIV`)
};

const de_rn_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. MMXXIV`)
};

const nl_rn_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. MMXXIV`)
};

const fr_rn_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. MMXXIV`)
};

const it_rn_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ad es. MMXXIV`)
};

const pt_br2_rn_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. MMXXIV`)
};

const pt_rn_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. MMXXIV`)
};

const ja_rn_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: MMXXIV`)
};

const zh_rn_placeholder_decode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如 MMXXIV`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_placeholder_decode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_placeholder_decode(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_placeholder_decode", locale)
	if (locale === "en") return en_rn_placeholder_decode(inputs)
	if (locale === "es") return es_rn_placeholder_decode(inputs)
	if (locale === "de") return de_rn_placeholder_decode(inputs)
	if (locale === "nl") return nl_rn_placeholder_decode(inputs)
	if (locale === "fr") return fr_rn_placeholder_decode(inputs)
	if (locale === "it") return it_rn_placeholder_decode(inputs)
	if (locale === "pt-BR") return pt_br2_rn_placeholder_decode(inputs)
	if (locale === "pt") return pt_rn_placeholder_decode(inputs)
	if (locale === "ja") return ja_rn_placeholder_decode(inputs)
	return zh_rn_placeholder_decode(inputs)
};